import { QueryFunctionContext } from '@tanstack/react-query'
import { WesService } from 'shared/services/WesService'

export const QUERY_KEY = 'favoritesByProductKey'

export const queryFavorites = (
  context: QueryFunctionContext<VP.DTT.Queries.WorkEntityService.ByProductKeyQueryKey>,
): Promise<VP.DTT.Models.WorkEntityService.WorkEntity<Gallery.ContentQuery.PreviewInfo>[]> => {
  const { queryKey } = context
  const [_, { locale, wesTenant, ownerId, authorizationHeader, productKey }] = queryKey

  return WesService.getAllFavorites(locale, wesTenant, ownerId, authorizationHeader, productKey)
}
